export default {
  path: '/customer',
  component: () => import('@/views/customers/customer-router.vue'),
  children: [
    {
      path: '',
      name: 'Customer',
      component: () => import('@/views/customers/pages/Customer.vue'),
      meta: {
        name: 'ลูกค้า',
        icon: '/icons/customer.svg',
        auth: true
      }
    },
    {
      path: 'customer-create',
      name: 'CustomerCreate',
      component: () => import('@/views/customers/pages/CustomerCreate.vue'),
      meta: {
        name: 'ลูกค้า',
        icon: '/icons/customer.svg',
        auth: true
      }
    },
    {
      path: 'customer-edit/:id',
      name: 'CustomerEdit',
      component: () => import('@/views/customers/pages/CustomerEdit.vue'),
      meta: {
        name: 'ลูกค้า',
        icon: '/icons/customer.svg',
        auth: true
      }
    },
    {
      path: 'customer-create-credit',
      name: 'CustomerCreateCredit',
      component: () => import('@/views/customers/pages/CustomerDetail/CustomerCreateCredit.vue'),
      meta: {
        name: 'ลูกค้า',
        icon: '/icons/customer.svg',
        auth: true
      }
    },
    {
      path: 'update-package/:id',
      name: 'UpdatePackage',
      component: () => import('@/views/customers/pages/CustomerDetail/UpdatePackage.vue'),
      meta: {
        name: 'ลูกค้า',
        icon: '/icons/customer.svg',
        auth: true
      }
    },

    {
      path: 'customer-detail/:id',
      name: 'CustomerDetail',
      component: () => import('@/views/customers/pages/CustomerDetail/CustomerDetail.vue'),
      meta: {
        auth: true
      }
    }
  ]
}
